import React, { useMemo, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

import Loading from '../../components/Loader/Loading'
import ArtworkCard from '../../components/Collection/ArtworkCard'

import { useActiveWeb3React } from '../../hooks'
import { getArtworksV3 } from '../../service/nft'
import { AuctionBake } from '../../constants/artwork'
import { contractAddresses } from '../../sushi/lib/constants'

const Wapper = styled.div`
  margin-top: -70px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const DropsWrapper = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  position: relative;
  padding: 30px 25px 0 25px;
  text-align: center;
`
const Banner = styled.div<{bg: string}>`
  width: 100%;
  min-height: 220px;
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
  `}
`
const Mask = styled.div`
  padding: 72px 10px 40px 10px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-bottom: 20px;
  `}
`
const Title = styled.div`
  font-size: 24px;
  font-family: 'Roboto-Bold';
  color: ${({ theme }) => theme.white};
  max-width: 700px;
  margin: 0 auto;
`
const Tips = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.white};
  font-family: 'Roboto-Regular';
  margin: 0 auto;
  margin-top: 15px;
  max-width: 700px;
  a {
  color: ${({ theme }) => theme.white};
  }
`
const Title2 = styled(Title)`
  font-size: 40px;
  color: ${({ theme }) => theme.text6};
`
const Tips2 = styled(Tips)`
  color: ${({ theme }) => theme.text6};
  a {
    color: ${({ theme }) => theme.text6};
  }
`
const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 459px);
  margin-top: 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    grid-template-columns: repeat(auto-fill, 350px);
  `}
`

const defaultList: [] = []
export default function Drops () {
  const { chainId, account } = useActiveWeb3React()
  const [artworkList, setArtworkList] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]

  const params = useMemo(() => {
    const ids = [
      '111-24638', '111-24635'
    ]
    return {
      nftType: -1,
      onSale: -3,
      offset: 0,
      limit: 100,
      ids: ids.join(','),
    }
  }, [])

  const fetchList = useCallback(async () => {
    setLoading(true)
    getArtworksV3(chainId as number, {
      ...params
    }, (err: any, data: any) => {
      setLoading(false)
      if (err) return
      if (data.code !== 0) return
      const list: any[] = data.data.list || []
      const artworks = list.map((d: any) => {
        let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
            || (d.price && Number(d.price))
            || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) &&  d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
        return {
          ...d,
          tokenId: d.nftId || d.id,
          nftLevel: level,
          status: d.status !== undefined ? d.status : 1,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      setArtworkList(artworks.length > 0 ? artworks : defaultList)

    })
  }, [params, chainId, account])

  // Init List
  useEffect(() => {
    fetchList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, chainId])

  return (
    <>
      <Loading open={loading} />
      <Wapper>
        <Banner bg={'/images/homeNew/banner_swog.jpg'}>
          <Mask>
            <Title>
            {`SWOG Special  500,000 sub NFT Drop`}
            </Title>
            <Tips>
            {`
               Daniel González, known as SWOG, is an emerging Spanish artist from Salamanca with over 500,000 subscribers and 125,000,000 plays on Youtube. This drop contains the special NFT to celebrate 500,000 subscribers to the SWOG youtube channel
              `}
              (
              <a href="https://www.youtube.com/SWOG" target="_blank" rel="noopener noreferrer">
                https://www.youtube.com/SWOG
              </a>
              )
              {`
                and ''Blame'', SWOG's first exclusive NFTed music video.
                `}
            </Tips>
            <Tips>
              12 artists portray their imagination inspired by the "Doughnut", the iconic logo of BakerySwap. Each artist using their unique styles, transform the Doughnut into their familiar visualisation, vividly changing the perspective from one another.
            </Tips>
          </Mask>
        </Banner>
        <DropsWrapper>
          <Title2>Custom Horror</Title2>
          <Tips2>            {`
              A special NFT to celebrate 500,000 subscribers to the SWOG youtube channel. This special 500k sub video is Powered by BakerySwap. More details and dedications for the video can be found here:
            `}
            <a href="https://www.youtube.com/watch?v=lrI_P1M7fDM" target="_blank" rel="noopener noreferrer">
              https://www.youtube.com/watch?v=lrI_P1M7fDM
            </a>
          </Tips2>
          <Tips2>
          {`
              Learn more about other SWOG exclusive releases like Blame included in this drop. Check youtube link here: 
            `}
            <a href="https://www.youtube.com/watch?v=aHZE-FSPa4g" target="_blank" rel="noopener noreferrer">
              https://www.youtube.com/watch?v=aHZE-FSPa4g.
            </a>
          </Tips2>
          {
            artworkList.length ?
              <ArtworkList>
                {
                  artworkList.map((d) => {
                    return (
                      <ArtworkCard key={d.id} artwork={d} width={427} height={427} padding={'16px'}></ArtworkCard>
                    )
                  })
                }
              </ArtworkList>
            : null
          }
        </DropsWrapper>
      </Wapper>
    </>
  )
}